/**
 * Companions sold one by one in the shop (ADR 0031, ADR 0007), in no pack: they
 * stand on the shop's home. Their beasts are in `data/companions.ts`.
 */
const PETS = [
    { id: 'black-cat', name: 'Chat noir', rarity: 'epic' },
    { id: 'slime', name: 'Slime', rarity: 'epic' },
    { id: 'mini-golem', name: 'Mini-golem', rarity: 'epic' },
    { id: 'mini-yeti', name: 'Mini-yéti', rarity: 'epic' },
];
export const COMPANION_SINGLES = {
    templates: [
        ...PETS.map((pet) => ({
            id: pet.id,
            lootable: false,
            name: pet.name,
            kind: 'equipment',
            slot: 'pet',
            rarity: pet.rarity,
            companion: pet.id,
            icon: `icon.${pet.id}`,
        })),
        {
            id: 'war-wolf',
            lootable: false,
            name: 'Loup de guerre',
            kind: 'equipment',
            slot: 'mount',
            rarity: 'legendary',
            companion: 'war-wolf',
            icon: 'icon.war-wolf',
        },
    ],
    offers: [
        {
            id: 'black-cat',
            name: 'Chat noir',
            blurb: 'Un petit chat d’un noir de jais aux yeux jaunes, qui trotte à ta droite sans un bruit.',
            items: [{ templateId: 'black-cat' }],
            priceCents: 299,
        },
        {
            id: 'slime',
            name: 'Slime',
            blurb: 'Une petite gelée translucide qui rebondit à tes côtés et ramasse ton butin.',
            items: [{ templateId: 'slime' }],
            priceCents: 299,
        },
        {
            id: 'mini-golem',
            name: 'Mini-golem',
            blurb: 'Un golem de pierre grand comme un chien, la mousse aux épaules, les yeux luisants.',
            items: [{ templateId: 'mini-golem' }],
            priceCents: 399,
        },
        {
            id: 'mini-yeti',
            name: 'Mini-yéti',
            blurb: 'Un bébé yéti tout en fourrure blanche, qui te suit en se dandinant.',
            items: [{ templateId: 'mini-yeti' }],
            priceCents: 349,
        },
        {
            id: 'war-wolf',
            name: 'Loup de guerre',
            blurb: 'Un grand loup sombre sous une selle de guerre en cuir et fer, qui te porte deux fois et demie plus vite que tes jambes.',
            items: [{ templateId: 'war-wolf' }],
            priceCents: 999,
        },
    ],
};
//# sourceMappingURL=companions.js.map